// src/VisualizationModeSelector.js
import React, { useRef, useEffect } from 'react';
import './VisualizationModeSelector.css';

const VisualizationModeSelector = ({
    mode = 'off',
    onModeChange,
    onClose,
}) => {
    const menuRef = useRef(null);

    // Close on click outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                // Check if click is on the NN button itself (don't close if clicking button)
                const nnButton = event.target.closest('.nn-viz-button');
                const vizToggle = event.target.closest('.tree-visualization-toggle');
                if (nnButton || vizToggle) return;
                
                onClose();
            }
        };

        // Use mousedown with capture:false (default) so it doesn't block other handlers
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClose]);

    // Close on Escape key
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [onClose]);

    const modeOptions = [
        { value: 'off', label: 'Off' },
        { value: 'placement-policy', label: 'Placement Policy' },
        { value: 'jump-policy', label: 'Jump Policy' },
        { value: 'saliency-0', label: 'Saliency Layer 0' },
        { value: 'saliency-1', label: 'Saliency Layer 1' },
        { value: 'saliency-2', label: 'Saliency Layer 2' },
        { value: 'saliency-3', label: 'Saliency Layer 3' },
        { value: 'saliency-4', label: 'Saliency Layer 4' },
        { value: 'saliency-5', label: 'Saliency Layer 5' },
    ];

    return (
        <div className="visualization-mode-selector" ref={menuRef}>
            <div className="visualization-mode-header">
                <span>NN Visualization</span>
            </div>
            <div className="visualization-mode-options">
                {modeOptions.map((option) => (
                    <button
                        key={option.value}
                        type="button"
                        className={`visualization-mode-option ${mode === option.value ? 'selected' : ''}`}
                        onClick={(e) => {
                            onModeChange(option.value);
                            e.currentTarget.blur();
                            if (option.value === 'off') {
                                onClose();
                            }
                        }}
                    >
                        <span className="mode-option-indicator">
                            {mode === option.value ? '●' : '○'}
                        </span>
                        <span className="mode-option-label">{option.label}</span>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default VisualizationModeSelector;